import * as React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  CardContent,
  Select,
  CircularProgress,
  MenuItem,
  useTheme,
  Modal,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

const AddStudent = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const [formData, setFormData] = React.useState({
    name: "",
    phone_number: "",
    alt_phone_number: "",
    class_id: "",
    branch_id: "",
    section_id: "",
    tuition_fee: "",
    discount_amount: "",
    reason: "",
    gender: "",
  });
  const [showModal, setShowModal] = React.useState(false);
  const token = localStorage.getItem("token");
  const direction = ["ar", "ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ar", "ku"].includes(i18n.language) ? "right" : "left";
  const [studentId, setStudentId] = React.useState(null);
  React.useEffect(() => {
    if (studentId) {
      console.log("Student ID updated, ready to give book:", studentId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId]);
  const handleChange = (name) => (e) => {
    setFormData({ ...formData, [name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.clever-school.com/api/students",
        {
          ...formData,
          discount_type: "currency",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // message.success(t("studentAdded"));
      const studentIdFromResponse = response.data?.student?.id;

      if (!studentIdFromResponse) {
        message.error("Error: Student ID is missing in response.");
        return;
      }

      // console.log("Student ID from response:", studentIdFromResponse);
      setStudentId(studentIdFromResponse);

      message.success(t("studentAdded"));
      setShowModal(true);
    } catch (error) {
      message.error(t("studentAddError"));
      console.error("Submission error:", error);
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      phone_number: "",
      alt_phone_number: "",
      class_id: "",
      branch_id: "",
      section_id: "",
      tuition_fee: "",
      discount_amount: "",
      reason: "",
      gender: "",
    });
  };

  const [userRole, setUserRole] = React.useState("");
  // eslint-disable-next-line no-unused-vars
  const [userBranch, setUserBranch] = React.useState("");

  React.useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const user = JSON.parse(userData);
        setUserRole(user.role);
        setUserBranch(user.branch_id);

        if (user.role !== "superadmin") {
          setFormData((prev) => ({
            ...prev,
            branch_id: user.branch_id.toString(),
          }));
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const formFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f5f5f5",
      borderRadius: "8px",
      "& fieldset": { border: "none" },
      "&:hover fieldset": { border: "none" },
      "&.Mui-focused fieldset": {
        border: "none",
        boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
    },
  };

  const formSelect = {
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": {
      border: "none",
      boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
    },
  };
  //TODO: Book =================
  const [BooksGiven, setBookGiven] = React.useState(null);
  const [isBooksLoading, setIsBooksLoading] = React.useState(false);
  const handleGiveBook = async () => {
    try {
      setIsBooksLoading(true);
      const response = await axios.post(
        "https://api.clever-school.com/api/books/give-books",
        {
          branch_id: parseInt(formData.branch_id),
          student_id: studentId, // Ensure it's not null
          class_id: parseInt(formData.class_id),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      message.success(t("BooksGive"));
      setBookGiven(response.data.given_books);
    } catch (error) {
      message.error(t("bookError"));
      console.error("Book error:", error);
    } finally {
      setIsBooksLoading(false);
    }
  };
  const printBooks = () => {
    if (!BooksGiven || !Array.isArray(BooksGiven)) return;

    const printContent = `
      <div class="header">
        <div class="school-info">
          <div class="student-info">
            <h3>${t("ناوی قوتابی")} : ${formData.name}</h3>
            <p>${t("پۆل")}: ${formData.class_id} - ${t(
      "هۆبە"
    )}: ${String.fromCharCode(64 + parseInt(formData.section_id))}</p>
          </div>
        </div>
        <h2 class="receipt-title">${t("پسولەی کتیب")}</h2>
        <table class="uniform-table">
          <thead>
            <tr>
              <th>#</th>
              <th>${t("ناوی کتیب")}</th>
            </tr>
          </thead>
          <tbody>
            ${BooksGiven.map(
              (BooksItem, index) => `
              <tr>
                <td>${index + 1}</td>
                <td>${BooksItem.book.name}</td>
              </tr>
            `
            ).join("")}
          </tbody>
        </table>
    
        <div class="footer">
          <p>${t("printed At")}: ${new Date().toLocaleString()}</p>
        </div>
      </div>
  
      <style>
        body {
          direction: rtl;
          text-align: right;
          color: #333;
          margin: 2rem;
        }
  
        .header {
          border-bottom: 2px solid #ccc;
          padding-bottom: 1rem;
          margin-bottom: 2rem;
        }
  
        .receipt-title {
          text-align: center;
          color: #1a237e;
          font-size: 1.5rem;
          margin: 2rem 0;
        }
  
        .uniform-table {
          width: 100%;
          border-collapse: collapse;
          margin: 2rem 0;
        }
  
        .uniform-table th, 
        .uniform-table td {
          padding: 12px;
          border: 1px solid #ddd;
          text-align: right;
        }
  
        .uniform-table th {
          background-color: #f8f9fa;
          font-weight: 600;
        }
  
        .footer {
          margin-top: 3rem;
          border-top: 2px solid #ccc;
          padding-top: 1rem;
          text-align: left;
        }
  
        @media print {
          body { 
            margin: 1cm;
            font-size: 14px;
          }
          .header {
            page-break-after: avoid;
          }
          .uniform-table {
            page-break-inside: avoid;
          }
        }
      </style>
    `;

    // دروستکردنی پەنجەرەیەکی نوێ بۆ چاپکردن
    const printWindow = window.open("", "_blank");
    printWindow.document.write(printContent);
    printWindow.document.close();

    // چاککردنی کاتیی کاردانەوەی چاپ
    printWindow.addEventListener("afterprint", () => {
      printWindow.close();
    });

    printWindow.print();
  };
  //TODO: Uniform =================

  // Add this state at the top of the component
  const [uniformsGiven, setUniformsGiven] = React.useState(null);
  const [isUniformLoading, setIsUniformLoading] = React.useState(false);
  // Modify handleGiveUniform to store the response
  const handleGiveUniform = async () => {
    try {
      setIsUniformLoading(true);
      const response = await axios.post(
        "https://api.clever-school.com/api/uniforms/give-uniform",
        {
          branch_id: parseInt(formData.branch_id),
          student_id: studentId,
          gender: formData.gender,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      message.success(t("uniformGiven"));
      setUniformsGiven(response.data.given_uniforms); // Store uniforms data
    } catch (error) {
      message.error(t("uniformError"));
      console.error("Uniform error:", error);
    } finally {
      setIsUniformLoading(false);
    }
  };

  const printUniforms = () => {
    if (!uniformsGiven || !Array.isArray(uniformsGiven)) return;

    const printContentBooks = `
      <div class="header">
        <div class="school-info">
          <div class="student-info">
            <h3>${t("ناوی قوتابی")} : ${formData.name}</h3>
            <p>${t("پۆل")}: ${formData.class_id} - ${t(
      "هۆبە"
    )}: ${String.fromCharCode(64 + parseInt(formData.section_id))}</p>
          </div>
        </div>
        <h2 class="receipt-title">${t("پسولەی جلو بەرگ")}</h2>
        <table class="uniform-table">
          <thead>
            <tr>
              <th>#</th>
              <th>${t("ناوی پۆشاک")}</th>
            </tr>
          </thead>
          <tbody>
            ${uniformsGiven
              .map(
                (uniformItem, index) => `
              <tr>
                <td>${index + 1}</td>
                <td>${uniformItem.uniform.name}</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
    
        <div class="footer">
          <p>${t("printed At")}: ${new Date().toLocaleString()}</p>
        </div>
      </div>
  
      <style>
        body {
          direction: rtl;
          text-align: right;
          color: #333;
          margin: 2rem;
        }
  
        .header {
          border-bottom: 2px solid #ccc;
          padding-bottom: 1rem;
          margin-bottom: 2rem;
        }
  
        .receipt-title {
          text-align: center;
          color: #1a237e;
          font-size: 1.5rem;
          margin: 2rem 0;
        }
  
        .uniform-table {
          width: 100%;
          border-collapse: collapse;
          margin: 2rem 0;
        }
  
        .uniform-table th, 
        .uniform-table td {
          padding: 12px;
          border: 1px solid #ddd;
          text-align: right;
        }
  
        .uniform-table th {
          background-color: #f8f9fa;
          font-weight: 600;
        }
  
        .footer {
          margin-top: 3rem;
          border-top: 2px solid #ccc;
          padding-top: 1rem;
          text-align: left;
        }
  
        @media print {
          body { 
            margin: 1cm;
            font-size: 14px;
          }
          .header {
            page-break-after: avoid;
          }
          .uniform-table {
            page-break-inside: avoid;
          }
        }
      </style>
    `;

    // دروستکردنی پەنجەرەیەکی نوێ بۆ چاپکردن
    const printWindow = window.open("", "_blank");
    printWindow.document.write(printContentBooks);
    printWindow.document.close();

    // چاککردنی کاتیی کاردانەوەی چاپ
    printWindow.addEventListener("afterprint", () => {
      printWindow.close();
    });

    printWindow.print();
  };

  const ModalContent = () => (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      sx={{
        backdropFilter: "blur(3px)",
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 500 },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
          border: "1px solid",
          borderColor: theme.palette.divider,
          outline: "none",
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontWeight: 600,
            color: theme.palette.primary.main,
            textAlign: "center",
            mb: 3,
            ...(direction === "rtl"),
          }}
        >
          {t("assignItems")}
        </Typography>

        {/* Books Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              mb: 1,
              color: theme.palette.text.secondary,
            }}
          >
            {t("books")}
          </Typography>
          <Button
            variant="contained"
            onClick={BooksGiven ? printBooks : handleGiveBook}
            disabled={isBooksLoading}
            sx={{
              width: "100%",
              py: 1.5,
              borderRadius: 2,
              transition: "all 0.2s ease",
              boxShadow: "none",
              "&:hover": {
                boxShadow: theme.shadows[2],
                transform: "translateY(-1px)",
                backgroundColor: BooksGiven
                  ? theme.palette.success.dark
                  : theme.palette.primary.dark,
              },
              "&:active": {
                transform: "translateY(0)",
              },
              backgroundColor: BooksGiven
                ? theme.palette.success.main
                : theme.palette.primary.main,
              color: "#fff",
              ...(direction === "rtl"),
            }}
          >
            {isBooksLoading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                <CircularProgress size={20} sx={{ color: "inherit" }} />
                {t("processing")}
              </Box>
            ) : BooksGiven ? (
              t("Print")
            ) : (
              t("givebook")
            )}
          </Button>
        </Box>

        {/* Uniform Section */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              mb: 1,
              color: theme.palette.text.secondary,
            }}
          >
            {t("uniform")}
          </Typography>
          <Button
            variant="contained"
            onClick={uniformsGiven ? printUniforms : handleGiveUniform}
            disabled={isUniformLoading}
            sx={{
              width: "100%",
              py: 1.5,
              borderRadius: 2,
              transition: "all 0.2s ease",
              boxShadow: "none",
              "&:hover": {
                boxShadow: theme.shadows[2],
                transform: "translateY(-1px)",
                backgroundColor: uniformsGiven
                  ? theme.palette.success.dark
                  : theme.palette.primary.dark,
              },
              "&:active": {
                transform: "translateY(0)",
              },
              backgroundColor: uniformsGiven
                ? theme.palette.success.main
                : theme.palette.primary.main,
              color: "#fff",
              ...(direction === "rtl"),
            }}
          >
            {isUniformLoading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                <CircularProgress size={20} sx={{ color: "inherit" }} />
                {t("processing")}
              </Box>
            ) : uniformsGiven ? (
              t("Print")
            ) : (
              t("giveuniform")
            )}
          </Button>
        </Box>

        <Button
          variant="outlined"
          color="success"
          fullWidth
          onClick={() => {
            setShowModal(false);
            navigate("/GetStudent");
          }}
          sx={{
            mt: 2,
            py: 1.5,
            borderRadius: 2,
            borderWidth: 2,
            "&:hover": {
              borderWidth: 2,
              backgroundColor: theme.palette.success.light,
            },
          }}
        >
          {t("done")}
        </Button>
      </Box>
    </Modal>
  );

  return (
    <Box
      sx={{
        maxWidth: 1200,
        margin: "40px auto",
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
        direction,
        textAlign,
      }}
    >
      <Paper
        elevation={2}
        sx={{
          borderRadius: 4,
          padding: theme.spacing(4),
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box component="form" onSubmit={handleSubmit}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 500, mb: 3 }}>
            {t("addStudent")}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("name")}
                </Typography>
                <TextField
                  fullWidth
                  value={formData.name}
                  onChange={handleChange("name")}
                  placeholder={t("enterName")}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("gender")}
                </Typography>
                <Select
                  fullWidth
                  value={formData.gender}
                  onChange={handleChange("gender")}
                  variant="outlined"
                  displayEmpty
                  required
                  sx={formSelect}
                >
                  <MenuItem value="" disabled>
                    {t("selectGender")}
                  </MenuItem>
                  <MenuItem value="M">{t("male")}</MenuItem>
                  <MenuItem value="F">{t("female")}</MenuItem>
                </Select>
              </CardContent>
            </Grid>

            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("phoneNumber")}
                </Typography>
                <TextField
                  fullWidth
                  value={formData.phone_number}
                  onChange={handleChange("phone_number")}
                  placeholder={t("enterPhoneNumber")}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("altPhoneNumber")}
                </Typography>
                <TextField
                  fullWidth
                  value={formData.alt_phone_number}
                  onChange={handleChange("alt_phone_number")}
                  placeholder={t("enterAltPhoneNumber")}
                  variant="outlined"
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            <Grid item xs={12} md={userRole === "superadmin" ? 4 : 6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("class")}
                </Typography>
                <Select
                  fullWidth
                  value={formData.class_id}
                  onChange={handleChange("class_id")}
                  variant="outlined"
                  displayEmpty
                  required
                  sx={formSelect}
                >
                  <MenuItem value="" disabled>
                    {t("selectClass")}
                  </MenuItem>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
                    <MenuItem key={num} value={num}>
                      {num}
                    </MenuItem>
                  ))}
                </Select>
              </CardContent>
            </Grid>

            <Grid item xs={12} md={userRole === "superadmin" ? 4 : 6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("section")}
                </Typography>
                <Select
                  fullWidth
                  value={formData.section_id}
                  onChange={handleChange("section_id")}
                  variant="outlined"
                  displayEmpty
                  required
                  sx={formSelect}
                >
                  <MenuItem value="" disabled>
                    {t("selectSection")}
                  </MenuItem>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
                    <MenuItem key={num} value={num}>
                      {String.fromCharCode(64 + num)}
                    </MenuItem>
                  ))}
                </Select>
              </CardContent>
            </Grid>

            {userRole === "superadmin" && (
              <Grid item xs={12} md={4}>
                <CardContent>
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    gutterBottom
                  >
                    {t("branch")}
                  </Typography>
                  <Select
                    fullWidth
                    value={formData.branch_id}
                    onChange={handleChange("branch_id")}
                    variant="outlined"
                    displayEmpty
                    required
                    sx={formSelect}
                  >
                    <MenuItem value="" disabled>
                      {t("selectBranch")}
                    </MenuItem>
                    <MenuItem value={1}>{t("branch1.1")}</MenuItem>
                    <MenuItem value={2}>{t("branch1.2")}</MenuItem>
                    <MenuItem value={3}>{t("branch1.3")}</MenuItem>
                  </Select>
                </CardContent>
              </Grid>
            )}

            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("tuitionFee")}
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  value={formData.tuition_fee}
                  onChange={handleChange("tuition_fee")}
                  placeholder={t("enterTuitionFee")}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("discountAmount")}
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  value={formData.discount_amount}
                  onChange={handleChange("discount_amount")}
                  placeholder={t("enterDiscountAmount")}
                  variant="outlined"
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            <Grid item xs={12}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("reason")}
                </Typography>
                <TextField
                  fullWidth
                  value={formData.reason}
                  onChange={handleChange("reason")}
                  placeholder={t("enterReason")}
                  variant="outlined"
                  multiline
                  rows={3}
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  mt: 4,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleReset}
                  sx={{
                    px: 4,
                    borderRadius: 2,
                    textTransform: "none",
                    color: theme.palette.info.main,
                    borderColor: theme.palette.info.main,
                  }}
                >
                  {t("reset")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate("/GetStudent")}
                  sx={{
                    px: 4,
                    borderRadius: 2,
                    textTransform: "none",
                    color: theme.palette.error.main,
                    borderColor: theme.palette.error.main,
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    px: 6,
                    borderRadius: 2,
                    textTransform: "none",
                    backgroundColor: theme.palette.success.main,
                    "&:hover": {
                      backgroundColor: theme.palette.success.dark,
                    },
                  }}
                >
                  {t("submit")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <ModalContent />
    </Box>
  );
};

export default AddStudent;
